// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"203":"e22b59a8","328":"bc1fbb67"}[chunkId] + ".chunk.css";
};